import { render } from "./ReportOppsByTeamMember.vue?vue&type=template&id=38b2c79a"
import script from "./ReportOppsByTeamMember.vue?vue&type=script&lang=js"
export * from "./ReportOppsByTeamMember.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__